import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  home: {
    id: 'common.home',
    defaultMessage: 'Home',
  },
  contactUs: {
    id: 'contactUs',
    defaultMessage: 'Contact Us',
  },
  contact: {
    id: 'contactUs.contact',
    defaultMessage: 'Contact',
  },
  officialDistributor: {
    id: 'contactUs.officialDistributor',
    defaultMessage: 'Official distributor',
  },
  sendEmail: {
    id: 'contactUs.sendEmail',
    defaultMessage: 'Send an e-mail',
  },
  contactAdditionalInf: {
    id: 'contactAdditionalInf',
    defaultMessage: 'Need additional information ?',
  },
  contactTextPt1: {
    id: 'contactTextPt1',
    defaultMessage: `Don't hesitate to contact directly the`,
  },
  contactTextPt2Part1: {
    id: 'contactTextPt2Part1',
    defaultMessage: 'authorized retailers',
  },
  contactTextPt2Part2: {
    id: 'contactTextPt2Part2',
    defaultMessage: ' nearest to your home.',
  },
});
